<template>
	<div class="page-list-box">
  <el-table :data="tableData" border v-loading="loading">
    <el-table-column prop="rank" label="排名" width="80"></el-table-column>
   <!-- 最佳现场(2) 和 最具潜力(3)：'8': '年度音乐人' 艺人名 + 艺人ID  -->
	   
       <template v-if="type == 2 || type == 3  || type == 8">
         <el-table-column prop="name" label="艺人名" min-width="120"></el-table-column>
         <el-table-column prop="userId" label="艺人ID" width="120"></el-table-column>
       </template>
       <template v-if="type == 2">
       		 <el-table-column prop="mainStyleIdView" label="主风格" min-width="120"></el-table-column>
       </template>
       <!-- 最佳厂牌(5)：厂牌名 + 厂牌ID -->
       <template v-if="type == 5">
         <el-table-column prop="name" label="厂牌名" min-width="120"></el-table-column>
         <el-table-column prop="userId" label="厂牌ID" width="120"></el-table-column>
       </template>
       
       <!-- 最佳场地(4)：场地名 + 场地ID -->
       <template v-if="type == 4">
         <el-table-column prop="name" label="场地名" min-width="120"></el-table-column>
         <el-table-column prop="userId" label="场地ID" width="120"></el-table-column>
       </template>
       
       <!-- 最佳体验音乐节(6)：音乐节名称 + 演出ID -->
       <template v-if="type == 6">
         <el-table-column prop="name" label="音乐节名称" min-width="120"></el-table-column>
         <el-table-column prop="userId" label="演出ID" width="120"></el-table-column>
       </template>
	   <!-- 最具人气(7)：特殊贡献(9) + 演出ID -->
	   <template v-if="type == 7 || type == 9">
	     <el-table-column prop="name" label="名称" min-width="120"></el-table-column>
	     <el-table-column prop="userId" label="ID" width="120"></el-table-column>
	   </template>
	   
    <el-table-column prop="voteNum" label="投票数"></el-table-column>
    <el-table-column prop="voteUserNum" label="投票人数"></el-table-column>
    <el-table-column label="操作" width="100">
      <template slot-scope="scope">
          <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              @click="edit(scope.row)"
              >管理</el-button
          >
      </template>
    </el-table-column>
  </el-table>
  <edit ref="Edit" @update="fetchData()"></edit>
  </div>
</template>

<script>
import Edit from './edit';
export default {
	components: {
	   Edit
	},
  props: {
    type: Number,        // 大类：2,3,4,5,6
    styleId: Number,     // 小类：1-6，无二级时传 null
    filterStatus: Number,// 筛选状态：null,0,1
    noSub: Boolean       // 是否无二级（直接展示表格）
  },
  
  data() {
    return {
      tableData: [],
      loading: false
    }
  },
  
  mounted() {
    this.fetchData()
  },
  
  watch: {
    filterStatus() {
      this.fetchData()
    }
  },
  
  methods: {
    fetchData() {
      this.loading = true      
      const params = {
        type: this.type,
        year: 2026
      }
      
      // 有二级时才传 styleId
      if (!this.noSub && this.styleId) {
        params.styleId = this.styleId
      }
      
      // 筛选条件
      if (this.filterStatus !== null && this.filterStatus !== undefined) {
        params.status = this.filterStatus
      }
      
      this.$request({
        url: '/lpa/dataList',
        method: 'post',
        params: params
      }).then(res => {
        const { state, msg, result } = res.data;
        if ( state == 1 && result) {
          this.tableData = (result || []).map((item, idx) => ({
            ...item
          }))
        } else {
          this.$message.error(msg || '获取数据失败')
        }
      }).catch(() => {
        this.$message.error('获取数据失败，请重试')
      }).finally(() => {
        this.loading = false
      })
    },
    
    //编辑事件
    edit(data) {
        this.$refs.Edit.show(data);
    }
  }
}
</script>